import { useAuth } from '@/contexts/AuthContext';
import { Button } from '@common/components/Button';
import Logo from '@common/components/Logo';
import { featureService } from '@common/index';
import {
    useEffect,
    useState
} from 'react';
import styles from './styles.module.scss';
import { FormProps } from './types';
import TypewriterText from './TypewriterText';

export const GetName = ({
    values, isFinished, onSubmit 
}: FormProps) => {
    const userName = values?.find((v) => v?.key === 'name')?.value || '';
    const {user} = useAuth();
    const accountName = user?.user_metadata?.name || '';
    const [name, setName] = useState(userName);
    const [showElements, setShowElements] = useState({
        logo: false,
        title: false,
        description: false,
        form: false
    });
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (accountName) {
            setName(accountName);
        }
    }, [accountName])

    useEffect(() => {
        const timeouts = [
            setTimeout(() => setShowElements(prev => ({ ...prev, logo: true })), 200),
            setTimeout(() => setShowElements(prev => ({ ...prev, title: true })), 600),
            setTimeout(() => setShowElements(prev => ({ ...prev, form: true })), 1400),
        ];

        return () => timeouts.forEach(clearTimeout);
    }, []);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setIsSubmitting(true);
        await featureService.sendUsername({ user_name: name });
        setIsSubmitting(false);
        onSubmit([{ key: 'name', value: name }]);
    }
    
    return (
        <>
            <div className={styles.message} style={{paddingTop: '30vh'}}>
                <div className={`${styles.animatedElement} ${showElements.logo ? styles.show : ''}`}>
                    <Logo size="22px" />
                </div>
                <div className={`${styles.animatedElement} ${showElements.title ? styles.show : ''}`}>
                    <p>
                        <TypewriterText 
                            text="Welcome," 
                            delay={600}
                            step={1}
                        />
                    </p>
                    <p>
                        <TypewriterText 
                            text="Before we get started, what should I call you?"
                            delay={1000}
                            step={3}
                        />
                    </p>
                </div>
                {!isFinished && (
                <div className={`${styles.animatedElement} ${showElements.form ? styles.show : ''}`}>
                    <div className={styles.form}>   
                        <div className={styles.formItem}>
                            <label>Enter your name</label>
                            <input 
                                type="text" 
                                placeholder="Your name" 
                                autoFocus
                                value={name}
                                onChange={(e) => setName(e.target.value)} 
                                onKeyDown={(e) => {
                                    if (e.key === 'Enter') {
                                        handleSubmit(e);
                                    }
                                }}
                            />
                        </div>
                        <Button 
                            className={styles.sendButton}
                            onClick={handleSubmit}
                            loading={isSubmitting}
                        >
                            Send
                        </Button>
                    </div>
                    <p className={styles.tips}>You can always change this later</p>
                </div>
                )}
            </div>
            {isFinished ? (
                <div className={styles.userMessage}>
                    {userName}
                </div>
            ) : null}
        </>
    );
}

export default GetName;